import React from 'react';
import { useTradingNotifications } from './useTradingNotifications';

export const TradingNotificationsContext =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  React.createContext<ReturnType<typeof useTradingNotifications>>(null);
